import "./controllers";
import "@hotwired/turbo-rails";
import "@tailwindplus/elements";
import { registerFrameMissingHandler } from "./lib/frame_missing";

registerFrameMissingHandler();

function getCookie(name) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(";").shift();
}

function setCookie(name, value, days) {
  let expires = "";
  if (days) {
    const date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    expires = `; expires=${date.toUTCString()}`;
  }
  document.cookie = `${name}=${value || ""}${expires}; path=/; SameSite=Lax`;
}

function checkTimeZone() {
  const detectedTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  if (!detectedTimeZone) return;

  const persistentCookie = getCookie("browser_time_zone");
  if (detectedTimeZone !== persistentCookie) {
    setCookie("browser_time_zone", detectedTimeZone, 365);
  }

  const isSignedIn =
    document
      .querySelector('meta[name="user-signed-in"]')
      ?.getAttribute("content") === "true";
  if (!isSignedIn) return;

  const userTimeZoneMeta = document.querySelector(
    'meta[name="user-time-zone"]',
  );
  const serverTimeZone = userTimeZoneMeta?.getAttribute("content");

  if (!serverTimeZone || serverTimeZone !== detectedTimeZone) {
    const syncKey = `tz_sync_${detectedTimeZone}`;
    if (sessionStorage.getItem(syncKey)) return;
    sessionStorage.setItem(syncKey, "true");

    const csrfToken = document
      .querySelector('meta[name="csrf-token"]')
      ?.getAttribute("content");

    fetch("/settings/time_zone", {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": csrfToken,
      },
      body: JSON.stringify({
        time_zone: detectedTimeZone,
      }),
    }).then((response) => {
      if (response.ok) {
        if (userTimeZoneMeta)
          userTimeZoneMeta.setAttribute("content", detectedTimeZone);
        if (window.Turbo) {
          window.Turbo.visit(window.location.href, { action: "replace" });
        } else {
          window.location.replace(window.location.href);
        }
      }
    });
  }
}

document.addEventListener("turbo:load", checkTimeZone);
